import Image from "@p-ban/common/src/components/html/Image"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import type EstimateValues from "../../../../../types/params"
import ColorPattern from "../../../../components/1Click/form/ColorPattern/ColorPattern"

import bottomBlack from "./img/bottom_black.png"
import bottomWhite from "./img/bottom_white.png"
import bottomYellow from "./img/bottom_yellow.png"
import topBlack from "./img/top_black.png"
import topWhite from "./img/top_white.png"
import topYellow from "./img/top_yellow.png"

const getSilkColor = (values: EstimateValues) => {
  switch (values.silkColor) {
    case ESTIMATE_CONSTANT.シルク印刷色["白(リジッド)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["白(フレキシブル)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["白(メタル)"].value:
      return {
        top: topWhite,
        bottom: bottomWhite,
      }
    case ESTIMATE_CONSTANT.シルク印刷色["黒(リジッド)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["黒(フレキシブル)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["黒(メタル)"].value:
      return {
        top: topBlack,
        bottom: bottomBlack,
      }
    case ESTIMATE_CONSTANT.シルク印刷色["黄(リジッド)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["黄(メタル)"].value:
      return {
        top: topYellow,
        bottom: bottomYellow,
      }
  }

  throw new Error("シルク印刷色の値が不正です。")
}

type Props = {
  pattern: "both" | "top" | "bottom" | "none"
  values: EstimateValues
}

const SilkPrintPatternImage = ({ pattern, values }: Props) => {
  const color = getSilkColor(values)

  const showTop = pattern === "both" || pattern === "top"
  const showBottom = pattern === "both" || pattern === "bottom"

  return (
    <ColorPattern pattern={pattern} values={values}>
      {showTop && <Image src={color.top} alt="" width={30} height={30} />}
      {showBottom && <Image src={color.bottom} alt="" width={30} height={30} />}
    </ColorPattern>
  )
}

export default SilkPrintPatternImage
